export { default as QuickReply } from "./quickReply";
